/* ============================================================
   KISHI KAISEI — comportements du thème
   Sans dépendance. Tout passe par les API natives de Shopify
   (Ajax Cart API + Section Rendering API), donc les pixels,
   les applications et les analyses Shopify voient les événements.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};
  var settings = window.themeSettings || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  /* ---------- Révélations au scroll ---------- */
  function initReveal() {
    if (settings.animations === false || !('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    $$('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    var menu = $('#mobileMenu');
    var openBtn = $('#burger');
    var closeBtn = $('#closeMenu');
    if (!menu) return;

    function open() {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    $$('a', menu).forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) close();
    });
  }

  /* ---------- Panneau de recherche ---------- */
  function initSearch() {
    var panel = $('[data-search-panel]');
    var toggle = $('[data-search-toggle]');
    if (!panel || !toggle) return;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      var input = $('[data-search-input]', panel);
      if (input) input.focus();
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) open(); else close();
    });
    $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  /* ---------- Panier ---------- */
  var Cart = {
    drawer: function () { return $('[data-cart-drawer]'); },

    open: function () {
      var d = this.drawer();
      if (!d) return;
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      var d = this.drawer();
      if (!d) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { d.hidden = true; }, 350);
    },

    setCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    },

    /* Rafraîchit le panier latéral via la Section Rendering API de Shopify */
    refresh: function (thenOpen) {
      var self = this;
      return fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-cart-drawer]');
          var current = self.drawer();
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
          }
          if (thenOpen) self.open();
        })
        .catch(function () { /* silencieux : le panier reste accessible par sa page */ });
    },

    add: function (formData, button) {
      var self = this;
      var label = button ? $('[data-add-label]', button) : null;
      var original = label ? label.textContent : '';
      var errorBox = $('[data-form-error]');

      if (button) button.disabled = true;
      if (label) label.textContent = 'Ajout…';
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

      return fetch(routes.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw body;
            return body;
          });
        })
        .then(function () {
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              self.setCount(cart.item_count);
              if (label) label.textContent = 'Ajouté ✓';

              if (settings.cartType === 'page') {
                window.location.href = routes.cart_url || '/cart';
                return;
              }
              if (settings.cartType === 'drawer') {
                return self.refresh(true);
              }
            });
        })
        .catch(function (err) {
          var message = (err && (err.description || err.message)) || "Impossible d'ajouter au panier.";
          if (errorBox) {
            errorBox.textContent = message;
            errorBox.hidden = false;
          } else {
            window.alert(message);
          }
          if (label) label.textContent = original;
        })
        .then(function () {
          if (button) button.disabled = false;
          setTimeout(function () {
            if (label && label.textContent === 'Ajouté ✓') label.textContent = original;
          }, 1800);
        });
    },

    change: function (line, quantity) {
      var self = this;
      return fetch(routes.cart_change_url || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.setCount(cart.item_count);
          if (document.body.classList.contains('template-cart')) {
            window.location.reload();
            return;
          }
          return self.refresh(false);
        })
        .catch(function () { window.location.reload(); });
    }
  };

  function initCart() {
    $$('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (settings.cartType !== 'drawer') return;
        if (!Cart.drawer()) return;
        e.preventDefault();
        Cart.refresh(true);
      });
    });

    document.addEventListener('click', function (e) {
      var closer = e.target.closest('[data-cart-close]');
      if (closer) {
        e.preventDefault();
        Cart.close();
      }
    });

    document.addEventListener('keydown', function (e) {
      var d = Cart.drawer();
      if (e.key === 'Escape' && d && d.classList.contains('is-open')) Cart.close();
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('.product-form')) return;
      if (settings.cartType === 'none') return;
      e.preventDefault();
      Cart.add(new FormData(form), $('[data-add-to-cart]', form));
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;
      e.preventDefault();
      Cart.change(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.to, 10));
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      Cart.change(parseInt(input.dataset.line, 10), parseInt(input.value, 10));
    });
  }

  /* ---------- Sélecteur de quantité (fiche produit) ---------- */
  function initQuantity() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty button[data-step]');
      if (!btn) return;
      var input = $('input', btn.parentNode);
      if (!input) return;
      /* Respecte les règles de quantité Shopify : minimum, maximum, incrément */
      var step = parseInt(input.step, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || Infinity;
      var v = parseInt(input.value, 10) || min;
      v += (btn.dataset.step === '+' ? step : -step);
      input.value = Math.min(max, Math.max(min, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Recherche prédictive ---------- */
  function initPredictiveSearch() {
    if (settings.predictiveSearch === false) return;

    var input = $('[data-search-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;

    var form = input.closest('form');
    var timer = null;
    var controller = null;
    var lastTerm = '';

    function hide() {
      results.hidden = true;
      results.innerHTML = '';
      if (form) form.setAttribute('aria-expanded', 'false');
    }

    function search(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = (routes.predictive_search_url || '/search/suggest')
        + '?q=' + encodeURIComponent(term)
        + '&resources[type]=product,article,page,query'
        + '&resources[limit]=5'
        + '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-predictive-results-inner]');
          if (!fresh) { hide(); return; }
          results.innerHTML = fresh.outerHTML;
          results.hidden = false;
          if (form) form.setAttribute('aria-expanded', 'true');
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') hide();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (term === lastTerm) return;
      lastTerm = term;

      clearTimeout(timer);
      if (term.length < 2) { hide(); return; }
      timer = setTimeout(function () { search(term); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
      if (e.key === 'ArrowDown' && !results.hidden) {
        var first = results.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });

    document.addEventListener('click', function (e) {
      if (!results.hidden && !e.target.closest('[data-search-panel]')) hide();
    });
  }

  /* ---------- Sélecteurs de pays et de langue ---------- */
  function initLocalization() {
    $$('[data-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------- Sélecteur de variantes ---------- */
  function initVariants() {
    var picker = $('[data-variant-picker]');
    if (!picker) return;

    var dataEl = $('[data-variant-data]', picker);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = $$('[data-variant-select]', picker);
    var idInput = $('[data-variant-id]');
    var priceWrap = $('[data-price-wrapper]');
    var stockEl = $('[data-stock]');
    var addBtn = $('[data-add-to-cart]');
    var addLabel = addBtn ? $('[data-add-label]', addBtn) : null;
    var mainImage = $('[data-gallery-main] img');

    function currentOptions() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant(options) {
      return variants.filter(function (v) {
        return options.every(function (opt, i) { return v.options[i] === opt; });
      })[0];
    }

    function update() {
      var variant = findVariant(currentOptions());

      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Indisponible';
        return;
      }

      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = false;
      }

      if (priceWrap) {
        var html = '<span class="price-item' + (variant.compare_at_price > variant.price ? ' price-item--sale' : '') + '">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += '<s class="old">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceWrap.innerHTML = html;
      }

      if (stockEl) {
        stockEl.innerHTML = '<span class="d"></span>' + (variant.available ? 'En stock, expédié sous 48 h' : 'Actuellement épuisé');
        stockEl.classList.toggle('is-out', !variant.available);
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }

      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
        mainImage.removeAttribute('srcset');
      }

      /* Met l'URL à jour sans recharger : le partage et le retour arrière restent justes */
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery() {
    var thumbs = $$('[data-gallery-thumb]');
    if (!thumbs.length) return;
    var main = $('[data-gallery-main] img');
    if (!main) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.dataset.full;
        if (!full) return;
        main.src = full;
        main.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Filtres et tri de collection ---------- */
  function initFilters() {
    var form = $('[data-filter-form]');
    if (!form) return;

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-auto-submit]')) return;
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (value, key) {
        if (value !== '') clean.append(key, value);
      });
      window.location.search = clean.toString();
    });
  }

  /* ---------- Recommandations produit (chargement différé) ---------- */
  function initRecommendations() {
    var container = $('[data-product-recommendations]');
    if (!container || !container.dataset.url) return;

    fetch(container.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-product-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          container.innerHTML = fresh.innerHTML;
          initReveal();
        }
      })
      .catch(function () { /* pas de recommandations : la page reste valide */ });
  }

  /* ---------- Mot de passe oublié ---------- */
  function initRecoverToggle() {
    var togglers = $$('[data-toggle-recover]');
    if (!togglers.length) return;
    var recover = $('#RecoverPassword');
    var login = $('#LoginForm');
    togglers.forEach(function (b) {
      b.addEventListener('click', function () {
        if (recover) recover.classList.toggle('hide');
        if (login) login.classList.toggle('hide');
      });
    });
    if (window.location.hash === '#recover' && recover && login) {
      recover.classList.remove('hide');
      login.classList.add('hide');
    }
  }

  function init() {
    initReveal();
    initMobileMenu();
    initSearch();
    initCart();
    initQuantity();
    initVariants();
    initGallery();
    initFilters();
    initRecommendations();
    initRecoverToggle();
    initPredictiveSearch();
    initLocalization();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-initialise après une modification dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);
})();
